/**
 * Utility helpers for Review Data.
 * This file contains shared pure helpers used by multiple screens, services, or wrappers.
 */
export function buildReviewRows<T>(count: number, factory: (index: number) => T): T[] {
  return Array.from({ length: count }, (_value, index) => factory(index));
}

export function cycleValue<T>(values: readonly T[], index: number): T {
  return values[index % values.length] as T;
}

/**
 * BUSINESS LOGIC: formatSequence
 * Inputs: Uses the parameters, injected services, route state, or signal state declared by this file.
 * Output: Returns the documented value or updates component/service state without changing the public contract.
 * Processing: Coordinates validation, mapping, emitted events, API calls, or state updates already owned by this implementation.
 */
export function formatSequence(index: number, minDigits = 3): string {
  return String(index + 1).padStart(minDigits, '0');
}

/**
 * BUSINESS LOGIC: formatIsoReviewDate
 * Inputs: Uses the parameters, injected services, route state, or signal state declared by this file.
 * Output: Returns the documented value or updates component/service state without changing the public contract.
 * Processing: Coordinates validation, mapping, emitted events, API calls, or state updates already owned by this implementation.
 */
export function formatIsoReviewDate(index: number, daySpan = 28): string {
  const day = (index % daySpan) + 1;
  return `2026-04-${String(day).padStart(2, '0')}`;
}

/**
 * BUSINESS LOGIC: formatDisplayReviewDate
 * Inputs: Uses the parameters, injected services, route state, or signal state declared by this file.
 * Output: Returns the documented value or updates component/service state without changing the public contract.
 * Processing: Coordinates validation, mapping, emitted events, API calls, or state updates already owned by this implementation.
 */
export function formatDisplayReviewDate(index: number, suffix = ''): string {
  const day = (index % 28) + 1;
  const label = `${String(day).padStart(2, '0')} Apr 2026`;
  return suffix ? `${label} ${suffix}` : label;
}
